import { type HTMLAttributes, type Ref } from "react";

import { cn } from "../../lib/utils";

export interface ItemHeaderProps extends HTMLAttributes<HTMLDivElement> {
  ref?: Ref<HTMLDivElement>;
}

export const ItemHeader = ({ className, ref, ...props }: ItemHeaderProps) => (
  <div ref={ref} data-slot="item-header" className={cn("flex basis-full items-center justify-between gap-2", className)} {...props} />
);
